// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nT7C","clinicsSelect":"styles_clinicsSelect__2XqZp"};